import { GutterSize } from './types';

export function getGutterValue(gutter: GutterSize): string {
  if (gutter === 'sm') {
    return '5px';
  }

  if (gutter === 'md') {
    return '10px';
  }

  if (typeof gutter === 'number') {
    return `${gutter}px`;
  }

  return gutter;
}
